import { ReactNode, useEffect, useState } from 'react';
import { AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface SecaoObrigatoriaProps {
  value: string;
  titulo: string;
  /** Emoji legado OU um componente lucide — R1 do punch do Painel. */
  icone?: string | LucideIcon;
  children: ReactNode;
  camposObrigatorios?: string[];
  camposPreenchidos?: string[];
  defaultExpanded?: boolean;
}

export function SecaoObrigatoria({
  value,
  titulo,
  icone,
  children,
  camposObrigatorios = [],
  camposPreenchidos = [],
  defaultExpanded = false
}: SecaoObrigatoriaProps) {
  const totalObrigatorios = camposObrigatorios.length;
  const totalPreenchidos = camposPreenchidos.filter(c => camposObrigatorios.includes(c)).length;
  const temCamposFaltando = totalObrigatorios > 0 && totalPreenchidos < totalObrigatorios;
  const estaCompleto = totalObrigatorios > 0 && totalPreenchidos === totalObrigatorios;

  // Badge variant
  const badgeVariant = estaCompleto ? 'success' : temCamposFaltando ? 'destructive' : 'secondary';
  const badgeIcon = estaCompleto ? (
    <CheckCircle2 className="w-3 h-3 mr-1" />
  ) : temCamposFaltando ? (
    <AlertCircle className="w-3 h-3 mr-1" />
  ) : null;

  const badgeText = totalObrigatorios === 0 
    ? 'Opcional'
    : estaCompleto 
    ? 'Completo' 
    : `${totalPreenchidos}/${totalObrigatorios} campos`;

  return (
    <AccordionItem value={value}>
      <AccordionTrigger className="py-2 text-[11px] font-bold hover:no-underline">
        <div className="flex items-center justify-between w-full pr-2">
          <span className="flex items-center gap-2">
            {/* R1: aceita lucide direto; string continua funcionando pra quem
                ainda não migrou. */}
            {icone && (typeof icone === 'string'
              ? <span>{icone}</span>
              : <span className="text-muted-foreground">{(() => { const I = icone; return <I className="h-3 w-3" />; })()}</span>)}
            {titulo}
          </span>
          <Badge variant={badgeVariant} className="text-xs">
            {badgeIcon}
            {badgeText}
          </Badge>
        </div>
      </AccordionTrigger>
      <AccordionContent className="pt-3 pb-4">
        {children}
      </AccordionContent>
    </AccordionItem>
  );
}
